export const SET_DEFAULT_COLOR = "SET_DEFAULT_COLOR";
export const SET_DEFAULT_SYSTEM = "SET_DEFAULT_SYSTEM";

export function setDefaultColor(value) {
  return { type: "SET_DEFAULT_COLOR", value };
}

export function setDefaultSystem(value) {
  return { type: SET_DEFAULT_SYSTEM, value };
}
